export default "__VITE_ASSET__C29Gp4XN__"